import {
  HttpErrorResponse,
  HttpInterceptorFn,
  HttpResponse,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { ToastService } from '@/app/services/toast.service';
import { catchError, tap, throwError } from 'rxjs';
import { ERROR_MESSAGE, ErrorMessageType, SHOULD_SHOW_ERROR_TOAST, SHOULD_SHOW_SUCCESS_TOAST, SUCCESS_MESSAGE } from '../services/base.service';

export const toastInterceptor: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const url = req.url;
  const method = req.method.toUpperCase();

 const NO_SHOW_TOAST_RULES = [
    // 完全排除的URL（所有方法）
    { pattern: '/api/SystemOwner/list', methods: ['POST'] },
    { pattern: '/api/integrations/DcodeIntegration/families/compact', methods: ['GET'] },
    { pattern: '/api/SoftwareCenter/list', methods: ['POST'] },
    // SoftwareCenter?id= 只排除GET，不排除DELETE
    { pattern: '/api/SoftwareCenter?id=', methods: ['GET'] },
  ];

  const isExcluded = NO_SHOW_TOAST_RULES.some(rule => {
    const matchesUrl = url.includes(rule.pattern);
    const matchesMethod = rule.methods.includes('*') || rule.methods.includes(method);
    return matchesUrl && matchesMethod;
  });

  const shouldShowToastFromHardRules = !isExcluded;

  return next(req).pipe(
    tap((response) => {
      // (status 200-299)
      const shouldShowSuccessToastFromCustom = req.context.get(SHOULD_SHOW_SUCCESS_TOAST);
      if(shouldShowSuccessToastFromCustom === false) {
        // do nothing
      } else if ((shouldShowToastFromHardRules) && response instanceof HttpResponse && response.ok) {
        const customSuccessMessage = req.context.get(SUCCESS_MESSAGE);
        let successMessage = 'Request successful!';
        switch (method) {
          case 'POST':
            successMessage = customSuccessMessage || 'Request successfully!';
            break;
          case 'PUT':
            successMessage = 'Updated successfully!';
            break;
          case 'DELETE':
            successMessage = 'Deleted successfully!';
            break;
          case 'PATCH':
            successMessage = 'Modified successfully!';
            break;
        }

        toastService.showSuccess(successMessage);
      }
    }),
    catchError((error: HttpErrorResponse) => {
      console.error(error);
      const shouldShowErrorToastFromCustom = req.context.get(SHOULD_SHOW_ERROR_TOAST);
      if(shouldShowErrorToastFromCustom === false) {
        // do nothing
      } else {
        const customErrorMessage = req.context.get(ERROR_MESSAGE);
        let errorMessageByType = new Map<number | string, string>();
        customErrorMessage?.forEach((item: ErrorMessageType) => {
          errorMessageByType.set(item.type, item.message);
        });

        function getErrorMessages(statusCode: number | string) {
          return errorMessageByType.get(statusCode) || errorMessageByType.get('default');
        }
        switch (error.status) {
            case 400:
              toastService.showError( 'Error', getErrorMessages(400) || error.error.message, '');
            break;
          case 401:
            // toastService.showError( 'Error', 'Unauthorized','Authentication failed, please login again');
            break;
          case 403:
            toastService.showError(
              'Error',
              'HTTP 403 Forbidden',
              'Insufficient permissions, unable to access this resource',
  
            );
            break;
          case 404:
            toastService.showError(
              'Error',
              'HTTP 404 Not Found',
              'The requested resource does not exist',
            );
            break;
          case 500:
            toastService.showError(
              'Error',
              'Internal Server Error',
              'Internal server error, please try again later',
            );
            break;
          case 0:
              toastService.showError(
                'Error',
                `${error.status} Error`,
                `Request failed: ${error.message || 'Unknown error'}`
              );
            break;
  
          default:
            if (error.status >= 400) {
              toastService.showError(
                'Error',
                `${error.status} Error`,
                `Request failed: ${error.message || 'Unknown error'}`
              );
            }
        }
      }

      return throwError(() => error);
    })
  );
};
